<template>
    <div class="main-layout__container">
        <div class="content__header">
            <div class="content-header__title">Отчет об аукционах</div>

            <div class="content-header__background content-header__background--1-line-filters"></div>
        </div>

        <FilterPanel :columns="4">
            <UIDatePicker
                id="date"
                v-model="formDate"
                label="Дата"
                :options="{ enableTime: false }"
                :error-message="(errors?.date_from ?? []).concat(errors?.date_from ?? []).join() ?? ''"
            />

            <template #actions-right>
                <div class="filter-panel__action-right">
                    <UISimpleButton
                        button-type="clear"
                        class="filter-panel__action"
                        @clicked="onReset"
                    >
                        Сбросить фильтр
                    </UISimpleButton>
                </div>

                <div class="filter-panel__action-right">
                    <UISimpleButton
                        class="filter-panel__action"
                        :loading="downloadLoading"
                        @clicked="onDownload"
                    >
                        <template #icon>
                            <img v-svg-inline src="@/assets/icons/report.svg" />
                        </template>
                        Сформировать отчёт
                    </UISimpleButton>
                </div>
            </template>
        </FilterPanel>
    </div>
</template>

<script lang="ts" setup>
    import { computed, ref } from 'vue';
    import {
        ReportAuctionsForPeriodDownloadErrors,
        ReportAuctionsForPeriodRequestFilter,
    } from '@/types/report.type.ts';

    import { formatToUTC } from '@/utils/DateTimeFormatter.ts';

    import useDocumentDownloader from '@/utils/useDocumentDownloader.ts';

    import FilterPanel from '@/components/shared/FilterPanel/FilterPanel.vue';

    import UISimpleButton from '@/components/ui/UISimpleButton/UISimpleButton.vue';
    import UIDatePicker from '@/components/ui/UIDatePicker/UIDatePicker.vue';

    const { downloadAuctionsReport } = useDocumentDownloader();

    const form = ref<ReportAuctionsForPeriodRequestFilter>({
        date_from: undefined,
        date_to: undefined,
    });

    const errors = ref<ReportAuctionsForPeriodDownloadErrors | null>(null);
    const downloadLoading = ref<boolean>(false);

    const formDate = computed({
        get: () => form.value.date_from,
        set: (date: string) => {
            form.value.date_from = date;
            form.value.date_to = date;
        },
    });

    function onDownload(): void {
        downloadLoading.value = true;
        errors.value = null;

        downloadAuctionsReport('auctions-report.xlsx', mapFormToRequest())
            .catch((downloadErrors: ReportAuctionsForPeriodDownloadErrors) => {
                errors.value = downloadErrors;
            })
            .finally(() => {
                downloadLoading.value = false;
            });
    }

    function onReset(): void {
        form.value = {
            date_from: undefined,
            date_to: undefined,
        };
    }

    function mapFormToRequest(): ReportAuctionsForPeriodRequestFilter {
        const request: ReportAuctionsForPeriodRequestFilter = {};

        if (form.value.date_from !== undefined) {
            request.date_from = formatToUTC(form.value.date_from, {
                fromFormat: 'dd.LL.yyyy',
                toFormat: 'yyyy-LL-dd',
                withTime: false,
            });
        }

        if (form.value.date_to !== undefined) {
            request.date_to = formatToUTC(form.value.date_to, {
                fromFormat: 'dd.LL.yyyy',
                toFormat: 'yyyy-LL-dd',
                withTime: false,
            });
        }

        return request;
    }
</script>
